<!-- 招商代理  -->
<template>
  <div class='busagent'>
      <div class="banner">
        <img src="../assets/img/busagent-banner.png" width="100%"/>
        <div class="btnPostion">
        <Form btnText="申请加盟" :channel="true" />
        </div>
      </div>
      <Modular obj="BusAgent" name="modular1"></Modular>
      <Modular obj="BusAgent" name="modular2"></Modular>
      <Modular obj="BusAgent" name="modular3"></Modular>
      <img class="busagentImg" src="../assets/img/busagent-img3.png" width="50%" />
  </div>
</template>
<script>
import Form from '../components/Form'
import Modular from '../components/Modular'
export default {
  name:'',
  components: {
    Modular,
    Form
  },
  props:{},
  data() {
    return {

    };
  },
  computed: {},
  watch: {},
  created() {
 
  },
  mounted() {

  },
  //方法集合
  methods: {

  },
}
</script>
<style lang='scss'>
  //@import url(); 引入公共css类
  .banner{
    // position: relative;
    margin-bottom:50px;
    .btnPostion{
      margin-top:-105px;
      margin-left:40%;
      // transform: translate(-50%,0);
      position: relative;
      z-index:12;
      .mint-button--primary{
        background:#0179f3;
      }
    }
  }
  .busagentImg{
    display:block;
    margin:0 auto 89px;

  }
</style>